/**
 * The two public origins, in one place.
 *
 * Both surfaces need to link at each other — the apex sends people into the app
 * ("Try out Scheda", the agent-card CTA) and the app links back home — and they
 * are built as SEPARATE bundles, so a hard-coded string in each would drift.
 */

/** The Scheda app (subdomain). */
export const APP_URL =
  (import.meta.env.VITE_APP_URL as string | undefined) ?? "https://scheda.delgentic.com/";

/** The Delgentic marketing home (apex). Mirrors VITE_SITE_URL, used for sign-out too. */
export const SITE_URL =
  (import.meta.env.VITE_SITE_URL as string | undefined) ?? "https://delgentic.com/";

/**
 * Where the apex hands a visitor over to the Scheda app.
 *
 * <p>`mode` opens that pane of the app's sign-in modal on arrival. **Omit it** for a "Try
 * Scheda" style CTA: someone arriving from the company page has not seen the product yet, and
 * dropping them into an auth modal is a poor first impression of it. Only ask for an account
 * where the copy actually asks for one.
 *
 * <p>Lives here rather than in {@code CatalogApp} so the URL shape has one owner and can be
 * tested, the same reason {@code PublicLinks} exists on the server side.
 */
export function schedaAppUrl(mode?: "signin" | "signup"): string {
  const base = APP_URL.endsWith("/") ? APP_URL : `${APP_URL}/`;
  return mode ? `${base}?auth=${mode}` : base;
}
